/**
 * Host-aware MSI3 routing (msi3.com).
 * localStorage MSI3_HOST=1 previews dedicated-host routing on any host.
 */

export const MSI3_HOST_PREVIEW_KEY = "MSI3_HOST";

export const MSI3_MARKETING_SLUGS = Object.freeze(["pricing", "faculty", "faq"]);

/** Faculty with a grant land here after sign-in on the msi3 host. */
export const MSI3_FACULTY_LANDING_PATH = "/msi3/faculty/cases";

/** Everyone else signed in on the msi3 host lands on AcuityDrill. */
export const MSI3_DEFAULT_LANDING_PATH = "/clinical-hud-5";

export function isMsi3Host() {
  if (typeof window === "undefined") return false;
  try {
    if (window.localStorage?.getItem(MSI3_HOST_PREVIEW_KEY) === "1") return true;
  } catch {
    // localStorage may be unavailable (private mode).
  }
  const host = window.location.hostname.toLowerCase();
  return (
    host === "msi3.com" ||
    host.endsWith(".msi3.com") ||
    host === "msi3-com.web.app" ||
    host === "msi3-com.firebaseapp.com"
  );
}

/**
 * Post-sign-in / default-dashboard destination on the msi3 host.
 * Keys off faculty grant document existence (not admin role).
 * @param {{ hasGrant?: boolean }} [opts]
 * @returns {string}
 */
export function msi3SignedInLandingPath({ hasGrant = false } = {}) {
  return hasGrant ? MSI3_FACULTY_LANDING_PATH : MSI3_DEFAULT_LANDING_PATH;
}

/**
 * True when pathname is exactly the dashboard index (default landing),
 * not a deep link under /dashboard/*.
 * @param {string} [pathname]
 */
export function isDashboardIndexPath(pathname = "") {
  if (typeof pathname !== "string") return false;
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === "/dashboard";
}

export function msi3MarketingPagePath(slug) {
  if (!slug) return "/";
  return `/${slug}`;
}

export function isMsi3MarketingPath(pathname = "") {
  if (!isMsi3Host()) return false;
  if (typeof pathname !== "string") return false;
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (normalized === "/") return true;
  const segment = normalized.replace(/^\/+/, "").split("/")[0];
  return MSI3_MARKETING_SLUGS.includes(segment);
}
